import { createEntityAdapter } from '@reduxjs/toolkit';

import type { Tab } from '@/store/tabs/types.ts';

export const tabsAdapter = createEntityAdapter<Tab, Tab['id']>({
  selectId: (tab) => tab.id,
});
